// ---- flags.js ----

// Simple colour metadata – only main colours, not pixel perfect.
// You can expand this over time.
const FLAG_COLORS = {
  // Europe
  FR: ["blue", "white", "red"],
  DE: ["black", "red", "yellow"],
  IT: ["green", "white", "red"],
  IE: ["green", "white", "orange"],
  ES: ["red", "yellow"],
  PT: ["green", "red", "yellow"],
  NL: ["red", "white", "blue"],
  LU: ["red", "white", "blue"],
  BE: ["black", "yellow", "red"],
  PL: ["white", "red"],
  AT: ["red", "white"],
  CH: ["red", "white"],
  GB: ["red", "white", "blue"],
  NO: ["red", "white", "blue"],
  SE: ["blue", "yellow"],
  FI: ["blue", "white"],
  DK: ["red", "white"],
  GR: ["blue", "white"],
  UA: ["blue", "yellow"],
  RU: ["white", "blue", "red"],
  CZ: ["white", "red", "blue"],
  SK: ["white", "blue", "red"],
  SI: ["white", "blue", "red"],
  HU: ["red", "white", "green"],
  RO: ["blue", "yellow", "red"],
  BG: ["white", "green", "red"],
  HR: ["red", "white", "blue"],
  RS: ["red", "blue", "white"],
  BA: ["blue", "yellow", "white"],
  MK: ["red", "yellow"],
  XK: ["blue", "yellow", "white"],

  // Americas
  US: ["red", "white", "blue"],
  CA: ["red", "white"],
  BR: ["green", "yellow", "blue"],
  AR: ["blue", "white", "yellow"],
  CL: ["red", "white", "blue"],
  CO: ["yellow", "blue", "red"],
  VE: ["yellow", "blue", "red"],
  EC: ["yellow", "blue", "red"],
  PE: ["red", "white"],
  MX: ["green", "white", "red"],
  CU: ["red", "white", "blue"],
  DO: ["red", "white", "blue"],
  HT: ["blue", "red"],
  JM: ["green", "yellow", "black"],
  TT: ["red", "white", "black"],
  UY: ["blue", "white", "yellow"],
  PY: ["red", "white", "blue"],
  BO: ["red", "yellow", "green"],
  GY: ["green", "yellow", "red"],
  SR: ["green", "white", "red", "yellow"],

  // Africa (lots of similar tricolours)
  EG: ["red", "white", "black"],
  MA: ["red", "green"],
  DZ: ["green", "white", "red"],
  TN: ["red", "white"],
  LY: ["red", "black", "green"],
  SD: ["red", "white", "black", "green"],
  SS: ["blue", "red", "green", "black", "white", "yellow"],
  ET: ["green", "yellow", "red", "blue"],
  KE: ["black", "red", "green", "white"],
  TZ: ["green", "blue", "yellow", "black"],
  UG: ["black", "yellow", "red"],
  RW: ["blue", "yellow", "green"],
  BI: ["red", "white", "green"],
  SO: ["blue", "white"],
  DJ: ["green", "white", "blue", "red"],
  ER: ["green", "blue", "red", "yellow"],
  GH: ["red", "yellow", "green", "black"],
  CI: ["orange", "white", "green"],
  NG: ["green", "white"],
  NE: ["orange", "white", "green"],
  ML: ["green", "yellow", "red"],
  SN: ["green", "yellow", "red"],
  GM: ["red", "blue", "green", "white"],
  GN: ["red", "yellow", "green"],
  SL: ["green", "white", "blue"],
  LR: ["red", "white", "blue"],
  CM: ["green", "red", "yellow"],
  GA: ["green", "yellow", "blue"],
  CG: ["green", "yellow", "red"],
  CD: ["blue", "red", "yellow"],
  AO: ["red", "black", "yellow"],
  NA: ["blue", "green", "red", "white", "yellow"],
  ZA: ["green", "yellow", "black", "red", "blue", "white"],
  BW: ["blue", "white", "black"],
  ZM: ["green", "red", "black", "orange"],
  ZW: ["green", "yellow", "red", "black", "white"],

  // Asia
  CN: ["red", "yellow"],
  JP: ["white", "red"],
  KR: ["white", "red", "blue", "black"],
  KP: ["red", "white", "blue"],
  IN: ["orange", "white", "green", "blue"],
  PK: ["green", "white"],
  BD: ["green", "red"],
  TH: ["red", "white", "blue"],
  VN: ["red", "yellow"],
  LA: ["red", "blue", "white"],
  MM: ["yellow", "green", "red", "white"],
  KH: ["blue", "red", "white"],
  PH: ["blue", "red", "white", "yellow"],
  MY: ["blue", "yellow", "red", "white"],
  SG: ["red", "white"],
  ID: ["red", "white"],
  SA: ["green", "white"],
  AE: ["red", "green", "white", "black"],
  QA: ["maroon", "white"],
  OM: ["red", "white", "green"],
  KW: ["green", "white", "red", "black"],
  IR: ["green", "white", "red"],
  IQ: ["red", "white", "black", "green"],
  JO: ["black", "white", "green", "red"],
  LB: ["red", "white", "green"],
  IL: ["blue", "white"],
  TR: ["red", "white"],
  GE: ["white", "red"],
  AM: ["red", "blue", "orange"],
  AZ: ["blue", "red", "green", "white"],

  // Oceania
  AU: ["blue", "red", "white"],
  NZ: ["blue", "red", "white"],
  FJ: ["lightblue", "red", "white"],
  PG: ["black", "red", "yellow", "white"],
  TO: ["red", "white"],
  WS: ["red", "white", "blue"],
  SB: ["blue", "yellow", "green"],
  VU: ["black", "red", "green", "yellow"],

  // Specials / UK nations
  "gb-eng": ["red", "white"],
  "gb-sct": ["blue", "white"],
  "gb-wls": ["green", "white", "red"],
  nir: ["red", "white"],
};

// Each entry: name, ISO code, region, difficulty (1–10)

const FLAGS = [
  { name: "Afghanistan", code: "AF", region: "Asia", difficulty: 6 },
  { name: "Albania", code: "AL", region: "Europe", difficulty: 6 },
  { name: "Algeria", code: "DZ", region: "Africa", difficulty: 4 },
  { name: "Andorra", code: "AD", region: "Europe", difficulty: 6 },
  { name: "Angola", code: "AO", region: "Africa", difficulty: 5 },
  {
    name: "Antigua and Barbuda",
    code: "AG",
    region: "Americas",
    difficulty: 7,
  },
  { name: "Argentina", code: "AR", region: "Americas", difficulty: 3 },
  { name: "Armenia", code: "AM", region: "Asia", difficulty: 5 },
  { name: "Australia", code: "AU", region: "Oceania", difficulty: 2 },
  { name: "Austria", code: "AT", region: "Europe", difficulty: 2 },
  { name: "Azerbaijan", code: "AZ", region: "Asia", difficulty: 5 },
  { name: "Bahamas", code: "BS", region: "Americas", difficulty: 5 },
  { name: "Bahrain", code: "BH", region: "Asia", difficulty: 5 },
  { name: "Bangladesh", code: "BD", region: "Asia", difficulty: 4 },
  { name: "Barbados", code: "BB", region: "Americas", difficulty: 6 },
  { name: "Belarus", code: "BY", region: "Europe", difficulty: 4 },
  { name: "Belgium", code: "BE", region: "Europe", difficulty: 2 },
  { name: "Belize", code: "BZ", region: "Americas", difficulty: 6 },
  { name: "Benin", code: "BJ", region: "Africa", difficulty: 6 },
  { name: "Bhutan", code: "BT", region: "Asia", difficulty: 8 },
  { name: "Bolivia", code: "BO", region: "Americas", difficulty: 5 },
  {
    name: "Bosnia and Herzegovina",
    code: "BA",
    region: "Europe",
    difficulty: 5,
  },
  { name: "Botswana", code: "BW", region: "Africa", difficulty: 5 },
  { name: "Brazil", code: "BR", region: "Americas", difficulty: 2 },
  { name: "Brunei", code: "BN", region: "Asia", difficulty: 7 },
  { name: "Bulgaria", code: "BG", region: "Europe", difficulty: 3 },
  { name: "Burkina Faso", code: "BF", region: "Africa", difficulty: 6 },
  { name: "Burundi", code: "BI", region: "Africa", difficulty: 7 },
  { name: "Cambodia", code: "KH", region: "Asia", difficulty: 6 },
  { name: "Cameroon", code: "CM", region: "Africa", difficulty: 5 },
  { name: "Canada", code: "CA", region: "Americas", difficulty: 1 },
  { name: "Cape Verde", code: "CV", region: "Africa", difficulty: 7 },
  {
    name: "Central African Republic",
    code: "CF",
    region: "Africa",
    difficulty: 7,
  },
  { name: "Chad", code: "TD", region: "Africa", difficulty: 6 },
  { name: "Chile", code: "CL", region: "Americas", difficulty: 3 },
  { name: "China", code: "CN", region: "Asia", difficulty: 1 },
  { name: "Colombia", code: "CO", region: "Americas", difficulty: 3 },
  { name: "Comoros", code: "KM", region: "Africa", difficulty: 8 },
  { name: "Congo (Republic)", code: "CG", region: "Africa", difficulty: 6 },
  { name: "Congo (DRC)", code: "CD", region: "Africa", difficulty: 6 },
  { name: "Costa Rica", code: "CR", region: "Americas", difficulty: 4 },
  { name: "Croatia", code: "HR", region: "Europe", difficulty: 4 },
  { name: "Cuba", code: "CU", region: "Americas", difficulty: 4 },
  { name: "Cyprus", code: "CY", region: "Europe", difficulty: 5 },
  { name: "Czech Republic", code: "CZ", region: "Europe", difficulty: 3 },
  { name: "Denmark", code: "DK", region: "Europe", difficulty: 2 },
  { name: "Djibouti", code: "DJ", region: "Africa", difficulty: 7 },
  { name: "Dominica", code: "DM", region: "Americas", difficulty: 7 },
  { name: "Dominican Republic", code: "DO", region: "Americas", difficulty: 4 },
  { name: "Ecuador", code: "EC", region: "Americas", difficulty: 3 },
  { name: "Egypt", code: "EG", region: "Africa", difficulty: 3 },
  { name: "El Salvador", code: "SV", region: "Americas", difficulty: 4 },
  { name: "Equatorial Guinea", code: "GQ", region: "Africa", difficulty: 8 },
  { name: "Eritrea", code: "ER", region: "Africa", difficulty: 8 },
  { name: "Estonia", code: "EE", region: "Europe", difficulty: 4 },
  { name: "Eswatini", code: "SZ", region: "Africa", difficulty: 7 },
  { name: "Ethiopia", code: "ET", region: "Africa", difficulty: 4 },
  { name: "Fiji", code: "FJ", region: "Oceania", difficulty: 5 },
  { name: "Finland", code: "FI", region: "Europe", difficulty: 2 },
  { name: "France", code: "FR", region: "Europe", difficulty: 1 },
  { name: "Gabon", code: "GA", region: "Africa", difficulty: 6 },
  { name: "Gambia", code: "GM", region: "Africa", difficulty: 6 },
  { name: "Georgia", code: "GE", region: "Asia", difficulty: 5 },
  { name: "Germany", code: "DE", region: "Europe", difficulty: 1 },
  { name: "Ghana", code: "GH", region: "Africa", difficulty: 4 },
  { name: "Greece", code: "GR", region: "Europe", difficulty: 2 },
  { name: "Grenada", code: "GD", region: "Americas", difficulty: 7 },
  { name: "Guatemala", code: "GT", region: "Americas", difficulty: 4 },
  { name: "Guinea", code: "GN", region: "Africa", difficulty: 6 },
  { name: "Guinea-Bissau", code: "GW", region: "Africa", difficulty: 7 },
  { name: "Guyana", code: "GY", region: "Americas", difficulty: 6 },
  { name: "Haiti", code: "HT", region: "Americas", difficulty: 6 },
  { name: "Honduras", code: "HN", region: "Americas", difficulty: 4 },
  { name: "Hungary", code: "HU", region: "Europe", difficulty: 3 },
  { name: "Iceland", code: "IS", region: "Europe", difficulty: 3 },
  { name: "India", code: "IN", region: "Asia", difficulty: 2 },
  { name: "Indonesia", code: "ID", region: "Asia", difficulty: 2 },
  { name: "Iran", code: "IR", region: "Asia", difficulty: 4 },
  { name: "Iraq", code: "IQ", region: "Asia", difficulty: 4 },
  { name: "Ireland", code: "IE", region: "Europe", difficulty: 2 },
  { name: "Israel", code: "IL", region: "Asia", difficulty: 3 },
  { name: "Italy", code: "IT", region: "Europe", difficulty: 1 },
  { name: "Jamaica", code: "JM", region: "Americas", difficulty: 4 },
  { name: "Japan", code: "JP", region: "Asia", difficulty: 1 },
  { name: "Jordan", code: "JO", region: "Asia", difficulty: 4 },
  { name: "Kazakhstan", code: "KZ", region: "Asia", difficulty: 5 },
  { name: "Kenya", code: "KE", region: "Africa", difficulty: 3 },
  { name: "Kiribati", code: "KI", region: "Oceania", difficulty: 8 },
  { name: "Kuwait", code: "KW", region: "Asia", difficulty: 5 },
  { name: "Kyrgyzstan", code: "KG", region: "Asia", difficulty: 6 },
  { name: "Laos", code: "LA", region: "Asia", difficulty: 6 },
  { name: "Latvia", code: "LV", region: "Europe", difficulty: 4 },
  { name: "Lebanon", code: "LB", region: "Asia", difficulty: 5 },
  { name: "Lesotho", code: "LS", region: "Africa", difficulty: 6 },
  { name: "Liberia", code: "LR", region: "Africa", difficulty: 6 },
  { name: "Libya", code: "LY", region: "Africa", difficulty: 5 },
  { name: "Liechtenstein", code: "LI", region: "Europe", difficulty: 6 },
  { name: "Lithuania", code: "LT", region: "Europe", difficulty: 3 },
  { name: "Luxembourg", code: "LU", region: "Europe", difficulty: 4 },
  { name: "Madagascar", code: "MG", region: "Africa", difficulty: 5 },
  { name: "Malawi", code: "MW", region: "Africa", difficulty: 6 },
  { name: "Malaysia", code: "MY", region: "Asia", difficulty: 3 },
  { name: "Maldives", code: "MV", region: "Asia", difficulty: 7 },
  { name: "Mali", code: "ML", region: "Africa", difficulty: 5 },
  { name: "Malta", code: "MT", region: "Europe", difficulty: 5 },
  { name: "Marshall Islands", code: "MH", region: "Oceania", difficulty: 8 },
  { name: "Mauritania", code: "MR", region: "Africa", difficulty: 6 },
  { name: "Mauritius", code: "MU", region: "Africa", difficulty: 5 },
  { name: "Mexico", code: "MX", region: "Americas", difficulty: 3 },
  { name: "Micronesia", code: "FM", region: "Oceania", difficulty: 8 },
  { name: "Moldova", code: "MD", region: "Europe", difficulty: 5 },
  { name: "Monaco", code: "MC", region: "Europe", difficulty: 5 },
  { name: "Mongolia", code: "MN", region: "Asia", difficulty: 5 },
  { name: "Montenegro", code: "ME", region: "Europe", difficulty: 6 },
  { name: "Morocco", code: "MA", region: "Africa", difficulty: 3 },
  { name: "Mozambique", code: "MZ", region: "Africa", difficulty: 6 },
  { name: "Myanmar", code: "MM", region: "Asia", difficulty: 5 },
  { name: "Namibia", code: "NA", region: "Africa", difficulty: 5 },
  { name: "Nauru", code: "NR", region: "Oceania", difficulty: 8 },
  { name: "Nepal", code: "NP", region: "Asia", difficulty: 5 },
  { name: "Netherlands", code: "NL", region: "Europe", difficulty: 2 },
  { name: "New Zealand", code: "NZ", region: "Oceania", difficulty: 2 },
  { name: "Nicaragua", code: "NI", region: "Americas", difficulty: 4 },
  { name: "Niger", code: "NE", region: "Africa", difficulty: 6 },
  { name: "Nigeria", code: "NG", region: "Africa", difficulty: 4 },
  { name: "North Korea", code: "KP", region: "Asia", difficulty: 4 },
  { name: "North Macedonia", code: "MK", region: "Europe", difficulty: 5 },
  { name: "Norway", code: "NO", region: "Europe", difficulty: 2 },
  { name: "Oman", code: "OM", region: "Asia", difficulty: 5 },
  { name: "Pakistan", code: "PK", region: "Asia", difficulty: 3 },
  { name: "Palau", code: "PW", region: "Oceania", difficulty: 7 },
  { name: "Panama", code: "PA", region: "Americas", difficulty: 4 },
  { name: "Papua New Guinea", code: "PG", region: "Oceania", difficulty: 7 },
  { name: "Paraguay", code: "PY", region: "Americas", difficulty: 4 },
  { name: "Peru", code: "PE", region: "Americas", difficulty: 3 },
  { name: "Philippines", code: "PH", region: "Asia", difficulty: 3 },
  { name: "Poland", code: "PL", region: "Europe", difficulty: 2 },
  { name: "Portugal", code: "PT", region: "Europe", difficulty: 2 },
  { name: "Qatar", code: "QA", region: "Asia", difficulty: 5 },
  { name: "Romania", code: "RO", region: "Europe", difficulty: 3 },
  { name: "Russia", code: "RU", region: "Europe", difficulty: 2 },
  { name: "Rwanda", code: "RW", region: "Africa", difficulty: 6 },
  {
    name: "Saint Kitts and Nevis",
    code: "KN",
    region: "Americas",
    difficulty: 8,
  },
  { name: "Saint Lucia", code: "LC", region: "Americas", difficulty: 8 },
  {
    name: "Saint Vincent and the Grenadines",
    code: "VC",
    region: "Americas",
    difficulty: 8,
  },
  { name: "Samoa", code: "WS", region: "Oceania", difficulty: 7 },
  { name: "San Marino", code: "SM", region: "Europe", difficulty: 6 },
  {
    name: "Sao Tome and Principe",
    code: "ST",
    region: "Africa",
    difficulty: 8,
  },
  { name: "Saudi Arabia", code: "SA", region: "Asia", difficulty: 3 },
  { name: "Senegal", code: "SN", region: "Africa", difficulty: 5 },
  { name: "Serbia", code: "RS", region: "Europe", difficulty: 4 },
  { name: "Seychelles", code: "SC", region: "Africa", difficulty: 7 },
  { name: "Sierra Leone", code: "SL", region: "Africa", difficulty: 6 },
  { name: "Singapore", code: "SG", region: "Asia", difficulty: 2 },
  { name: "Slovakia", code: "SK", region: "Europe", difficulty: 3 },
  { name: "Slovenia", code: "SI", region: "Europe", difficulty: 4 },
  { name: "Solomon Islands", code: "SB", region: "Oceania", difficulty: 7 },
  { name: "Somalia", code: "SO", region: "Africa", difficulty: 6 },
  { name: "South Africa", code: "ZA", region: "Africa", difficulty: 2 },
  { name: "South Korea", code: "KR", region: "Asia", difficulty: 2 },
  { name: "South Sudan", code: "SS", region: "Africa", difficulty: 6 },
  { name: "Spain", code: "ES", region: "Europe", difficulty: 1 },
  { name: "Sri Lanka", code: "LK", region: "Asia", difficulty: 4 },
  { name: "Sudan", code: "SD", region: "Africa", difficulty: 5 },
  { name: "Suriname", code: "SR", region: "Americas", difficulty: 6 },
  { name: "Sweden", code: "SE", region: "Europe", difficulty: 2 },
  { name: "Switzerland", code: "CH", region: "Europe", difficulty: 1 },
  { name: "Syria", code: "SY", region: "Asia", difficulty: 5 },
  { name: "Taiwan", code: "TW", region: "Asia", difficulty: 4 },
  { name: "Tajikistan", code: "TJ", region: "Asia", difficulty: 6 },
  { name: "Tanzania", code: "TZ", region: "Africa", difficulty: 4 },
  { name: "Thailand", code: "TH", region: "Asia", difficulty: 2 },
  { name: "Timor-Leste", code: "TL", region: "Asia", difficulty: 7 },
  { name: "Togo", code: "TG", region: "Africa", difficulty: 6 },
  { name: "Tonga", code: "TO", region: "Oceania", difficulty: 7 },
  {
    name: "Trinidad and Tobago",
    code: "TT",
    region: "Americas",
    difficulty: 5,
  },
  { name: "Tunisia", code: "TN", region: "Africa", difficulty: 4 },
  { name: "Turkey", code: "TR", region: "Asia", difficulty: 2 },
  { name: "Turkmenistan", code: "TM", region: "Asia", difficulty: 6 },
  { name: "Tuvalu", code: "TV", region: "Oceania", difficulty: 8 },
  { name: "Uganda", code: "UG", region: "Africa", difficulty: 4 },
  { name: "Ukraine", code: "UA", region: "Europe", difficulty: 3 },
  { name: "United Arab Emirates", code: "AE", region: "Asia", difficulty: 3 },
  { name: "United Kingdom", code: "GB", region: "Europe", difficulty: 1 },
  { name: "United States", code: "US", region: "Americas", difficulty: 1 },
  { name: "Uruguay", code: "UY", region: "Americas", difficulty: 3 },
  { name: "Uzbekistan", code: "UZ", region: "Asia", difficulty: 5 },
  { name: "Vanuatu", code: "VU", region: "Oceania", difficulty: 8 },
  { name: "Vatican City", code: "VA", region: "Europe", difficulty: 7 },
  { name: "Venezuela", code: "VE", region: "Americas", difficulty: 4 },
  { name: "Vietnam", code: "VN", region: "Asia", difficulty: 3 },
  { name: "Yemen", code: "YE", region: "Asia", difficulty: 4 },
  { name: "Zambia", code: "ZM", region: "Africa", difficulty: 4 },
  { name: "Zimbabwe", code: "ZW", region: "Africa", difficulty: 4 },
  // --- Additional territories, dependencies & regions ---
  { name: "Isle of Man", code: "IM", region: "Europe", difficulty: 7 },
  { name: "Gibraltar", code: "GI", region: "Europe", difficulty: 7 },
  { name: "Jersey", code: "JE", region: "Europe", difficulty: 7 },
  { name: "Guernsey", code: "GG", region: "Europe", difficulty: 7 },
  { name: "Greenland", code: "GL", region: "Europe", difficulty: 5 },
  { name: "Faroe Islands", code: "FO", region: "Europe", difficulty: 6 },
  { name: "Bermuda", code: "BM", region: "Americas", difficulty: 6 },
  { name: "Cayman Islands", code: "KY", region: "Americas", difficulty: 7 },
  {
    name: "British Virgin Islands",
    code: "VG",
    region: "Americas",
    difficulty: 7,
  },
  {
    name: "Turks and Caicos Islands",
    code: "TC",
    region: "Americas",
    difficulty: 7,
  },
  { name: "Puerto Rico", code: "PR", region: "Americas", difficulty: 4 },
  {
    name: "U.S. Virgin Islands",
    code: "VI",
    region: "Americas",
    difficulty: 6,
  },
  { name: "Guam", code: "GU", region: "Oceania", difficulty: 6 },
  {
    name: "Northern Mariana Islands",
    code: "MP",
    region: "Oceania",
    difficulty: 7,
  },
  { name: "American Samoa", code: "AS", region: "Oceania", difficulty: 7 },
  { name: "Cook Islands", code: "CK", region: "Oceania", difficulty: 8 },
  { name: "Niue", code: "NU", region: "Oceania", difficulty: 8 },
  { name: "Tokelau", code: "TK", region: "Oceania", difficulty: 8 },
  { name: "Pitcairn Islands", code: "PN", region: "Oceania", difficulty: 9 },
  { name: "French Polynesia", code: "PF", region: "Oceania", difficulty: 6 },
  { name: "New Caledonia", code: "NC", region: "Oceania", difficulty: 6 },
  { name: "Wallis and Futuna", code: "WF", region: "Oceania", difficulty: 8 },
  { name: "Hong Kong", code: "HK", region: "Asia", difficulty: 3 },
  { name: "Macau", code: "MO", region: "Asia", difficulty: 4 },
  { name: "Palestine", code: "PS", region: "Asia", difficulty: 5 },
  { name: "Western Sahara", code: "EH", region: "Africa", difficulty: 7 },
  { name: "Reunion", code: "RE", region: "Africa", difficulty: 7 },
  { name: "Mayotte", code: "YT", region: "Africa", difficulty: 7 },
  {
    name: "Saint Pierre and Miquelon",
    code: "PM",
    region: "Americas",
    difficulty: 8,
  },
  { name: "Martinique", code: "MQ", region: "Americas", difficulty: 7 },
  { name: "Guadeloupe", code: "GP", region: "Americas", difficulty: 7 },
  { name: "Aruba", code: "AW", region: "Americas", difficulty: 6 },
  { name: "Curacao", code: "CW", region: "Americas", difficulty: 6 },
  { name: "Sint Maarten", code: "SX", region: "Americas", difficulty: 7 },
  { name: "Anguilla", code: "AI", region: "Americas", difficulty: 7 },
  { name: "Montserrat", code: "MS", region: "Americas", difficulty: 7 },
  { name: "Falkland Islands", code: "FK", region: "Americas", difficulty: 6 },
  { name: "Saint Helena", code: "SH", region: "Africa", difficulty: 8 },
  { name: "Ascension Island", code: "AC", region: "Africa", difficulty: 8 },
  {
    name: "South Georgia and South Sandwich Islands",
    code: "GS",
    region: "Americas",
    difficulty: 9,
  },
  { name: "Kosovo", code: "XK", region: "Europe", difficulty: 5 },
  { name: "Scotland", code: "SCT", region: "Europe", difficulty: 5 },
  { name: "Wales", code: "WLS", region: "Europe", difficulty: 5 },
  { name: "England", code: "ENG", region: "Europe", difficulty: 4 },
  { name: "Greenland", code: "GL", region: "Europe", difficulty: 5 },
  { name: "Antarctica", code: "AQ", region: "Antarctica", difficulty: 9 },
  { name: "French Guiana", code: "GF", region: "Americas", difficulty: 6 },
  { name: "Saint Martin", code: "MF", region: "Americas", difficulty: 7 },
  { name: "Bonaire", code: "BQ", region: "Americas", difficulty: 7 },
  // Add these entries (or ensure existing ones include `img`)
  {
    name: "England",
    code: "gb-eng",
    region: "Europe",
    difficulty: 2,
    img: "https://upload.wikimedia.org/wikipedia/commons/b/be/Flag_of_England.svg",
  },
  {
    name: "Scotland",
    code: "gb-sct",
    region: "Europe",
    difficulty: 2,
    img: "https://upload.wikimedia.org/wikipedia/commons/1/10/Flag_of_Scotland.svg",
  },
  {
    name: "Wales",
    code: "gb-wls",
    region: "Europe",
    difficulty: 2,
    img: "https://upload.wikimedia.org/wikipedia/commons/d/dc/Flag_of_Wales.svg",
  },
  {
    name: "Northern Ireland",
    code: "gb-nir",
    region: "Europe",
    difficulty: 3,
  },
];

// ---- ENRICH FLAGS WITH COLOURS ----
const FLAGS_WITH_COLORS = FLAGS.map((f) => {
  const code = f.code || "";
  const colors =
    FLAG_COLORS[code] ||
    FLAG_COLORS[code.toUpperCase()] ||
    FLAG_COLORS[code.toLowerCase()] ||
    [];

  return {
    ...f,
    colors,
  };
});

export { FLAG_COLORS };
export default FLAGS_WITH_COLORS;
